import React from 'react'
import { GetCard } from '@web/walter-lib/api'
import { SettingsTabs } from './types'
import General from './views/General/General'
import Block from './views/Block/Block'
import Pin from './views/Pin/Pin'
import ThreeDS from './views/ThreeDS/ThreeDS'

interface Props {
    onClose: () => void
    setTab: (tab: SettingsTabs) => void
    tab: SettingsTabs
    card?: GetCard
}

function Content({ onClose, tab, setTab, card }: Props) {
    return (
        <>
            {tab === 'general' && <General tab={tab} setTab={setTab} card={card} />}
            {tab.startsWith('pin') && <Pin onClose={onClose} tab={tab} setTab={setTab} card={card} />}
            {tab.startsWith('block') && <Block onClose={() => setTab(SettingsTabs.general)} />}
            {tab.startsWith('threeDS') && <ThreeDS onClose={onClose} tab={tab} setTab={setTab} card={card} />}
        </>
    )
}

export default Content
